import * as geokit from "geokit";
import _ from "lodash";
import { v4 as uuid } from "uuid";
import firebase from "../firebase/firebase";
import axios from 'axios';
import {
  BULK_EDIT_MARKER,
  BULK_SET_PLACEHOLDER,
  EDIT_MARKER,
  FETCH_EVENTS_LOADING,
  FETCH_EVENTS_SUCCESS,
  FETCH_LOCATIONS_LOADING,
  FETCH_LOCATIONS_SUCCESS,
  GET_PLACEHOLDERS,
  MOVE_MARKERS,
  RESET_MARKER_KEY,
  SET_ACTIVE_MARKER,
  SET_BACKGROUND_IMAGE,
  SET_CENTER,
  SET_EVENT_ID,
  SET_INFO,
  SET_PLACEHOLDERS,
  SET_START_DATE,
  SET_TEMPLATE,
  TOGGLE_OVERLAY,
  UPDATE_MARKER,
  OMIT_QUESTION,
  SET_IMAGE_CAROUSEL,
  FETCH_IMAGES_SUCCESS,
  FETCH_IMAGES_FAIL,
  FETCH_IMAGES_LOADING,
  TRANSLATE_LOADING,
  TRANSLATE_FAIL,
} from "./types";
import { placeholder_questions, languages } from "../settings";

export const setBackgroundImage = (photo) => ({
  type: SET_BACKGROUND_IMAGE,
  payload: photo,
});

export const getEventTemplates = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_EVENTS_LOADING });
    const {
      currentUser: { uid },
    } = firebase.auth();

    const { docs: templates } = await firebase
      .firestore()
      .collection("event_templates")
      .get();
    const eventTemplates = templates.map((d) => ({ key: d.id, ...d.data() }));

    firebase
      .firestore()
      .collection(`users_ui/${uid}/events`)
      .onSnapshot(({ docs }) => {
        const userEvents = docs.map((d) => ({ key: d.id, ...d.data() }));

        dispatch({
          type: FETCH_EVENTS_SUCCESS,
          payload: {
            eventTemplates,
            userEvents,
          },
        });
      });
  } catch (e) {
    console.log(e);
  }
};

export const setTemplateId = (id) => ({
  type: SET_EVENT_ID,
  payload: id,
});

const getLocations = async (event) => {
  const { docs } = await firebase
    .firestore()
    .collection("event_templates")
    .doc(event)
    .collection("locations")
    .get();

  return docs.map((d) => ({ key: d.id, ...d.data() }));
};

export const resetMarkerKey = () => ({
  type: RESET_MARKER_KEY,
});

export const getTemplateLocations = (templateId) => async (dispatch) => {
  dispatch({ type: FETCH_LOCATIONS_LOADING });
  try {
    const locations = await getLocations(templateId);

    const template = await firebase
      .firestore()
      .collection("event_templates")
      .doc(templateId)
      .get();

    const placeholders = {};

    const result = locations.reduce((map, obj) => (map[obj.key] = { ...obj }, map), {});

    dispatch({ type: GET_PLACEHOLDERS, payload: placeholders });
    dispatch({ type: FETCH_LOCATIONS_SUCCESS, payload: result });
    dispatch({ type: SET_TEMPLATE, payload: template.data(), })
  } catch (e) {
    console.log(e);
  }
};

export const getCustomEventLocations = (id) => async (dispatch) => {
  dispatch({ type: FETCH_LOCATIONS_LOADING });
  try {
    const {
      currentUser: { uid },
    } = firebase.auth();
    const { docs } = await firebase
      .firestore()
      .collection(`users_ui/${uid}/events/${id}/locations`)
      .get();

    const template = await firebase
      .firestore()
      .collection('users_ui')
      .doc(uid)
      .collection('events')
      .doc(id)
      .get();

    const locations = docs.map((d) => ({ key: d.id, ...d.data() }));
    const result = locations.reduce((map, obj) => (map[obj.key] = { ...obj }, map), {});
    const placeholders = {};

    dispatch({ type: GET_PLACEHOLDERS, payload: placeholders });
    dispatch({ type: FETCH_LOCATIONS_SUCCESS, payload: result });
    dispatch({ type: SET_TEMPLATE, payload: template.data(), })
  } catch (e) {
    console.log(e);
  }
};

export const getImages = (eventId) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_IMAGES_LOADING, })
    const token = await firebase.auth().currentUser.getIdToken(true);
    const headers = { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json' 
    };

    const { data: { urls } } = await axios({
      method: 'POST',
      data: { eventId },
      url: 'https://us-central1-seekcity.cloudfunctions.net/getEventImages', 
      headers
    });

    dispatch({
      type: FETCH_IMAGES_SUCCESS,
      payload: urls
    })
  } catch (e) {
    dispatch({
      type: FETCH_IMAGES_FAIL,
    })
    console.log(e)
  }
}

export const setImageCarousel = (value) => ({
  type: SET_IMAGE_CAROUSEL,
  payload: value,
})

const writeBatch = async ({ 
  db, 
  id, 
  template: templateUser, 
  locations: locationsUser 
}) => {
  const {
    currentUser: { uid, email },
  } = firebase.auth();
  const batch = db.batch();
  const eventRef = db.collection("game_ids").doc(id);
  const evenrRefUser = db.collection(`users_ui/${uid}/events`).doc(id);
  const updatedOn = firebase.firestore.Timestamp.fromDate(new Date());

  const locations = _.cloneDeep(locationsUser);
  const template = _.cloneDeep(templateUser);

  replace(locations, '{', '', languages);
  replace(locations, '}', '', languages);

  replace(template, '}', '', languages);
  replace(template, '{', '', languages);

  batch.set(eventRef, { ...template, updatedOn, id }, { merge: true });
  batch.set(evenrRefUser, { 
    ...templateUser, 
    updatedOn, 
    id,
    author: email,
  }, { merge: true });

  locationsUser.forEach((l) => {
    const docRefUser = db
      .collection(`users_ui/${uid}/events/${id}/locations`)
      .doc(l.key);
    
      batch.set(docRefUser, l);
  });

  locations.forEach((l) => {
    const docRef = db.collection(`game_ids/${id}/locations`).doc(l.key);
    batch.set(docRef, l);
  })

  return await batch.commit();
};

const replace = (obj, placeholder, replaceWith, lng) => {
  if (!placeholder) return;

  const regexp = new RegExp(placeholder, "gi");
  Object.keys(obj).forEach((key) => {
    if (Array.isArray(obj[key])) {
      obj[key] = obj[key].map((x) => x.replaceAll(regexp, replaceWith));
    } else if (typeof obj[key] === "object") {
      replace(obj[key], placeholder, replaceWith, lng);
    } else if (typeof obj[key] === "string" && lng.some(l => key.includes('_' + l))) {
      if (key.includes('_no') && placeholder.includes('Thomas')) {
        console.log(placeholder, replaceWith, lng, key, obj[key])
      }
      obj[key] = obj[key].replaceAll(regexp, replaceWith);
    }
  });
};

export const saveEvent = (t, l, p, metadata) => async (dispatch) => {
  const { eventName } = metadata;
  if (_.size(l) < 1) {
    return dispatch(
      setInfo({
        status: 500,
        info: "An error occured, event not saved",
      })
    );
  }

  let template = { ...t, };
  let locations = _.cloneDeep(l)

  _.forEach(p, (val, key) => {
    const location = locations[key];
    Object.keys(val).forEach(title => {
      if (!Object.prototype.hasOwnProperty.call(location, title)) {
        locations[key][title] = `{{${val[title].value}}}`
      }
    })
  })

  locations = _.map((locations), (val, key) => ({ key, ...val }));
  const placeholders = _.cloneDeep(p);

  _.forEach(placeholders, (val, key) => 
    _.forEach(val, (v, k) => {
      replace(
        template, 
        _.find(locations, ['key', key])[k], 
        '{{' + v.value + '}}', 
        v.isCharacter ? languages : [v.lng]
      )

      replace(
        locations, 
        _.find(locations, ['key', key])[k], 
        '{{' + v.value + '}}', 
        v.isCharacter ? languages : [v.lng]
      )
    }))

  replace(template, '{{' + template.eventName + '}}' || "{{city}}", '{{' + eventName + '}}', languages);
  replace(locations, '{{' + template.eventName + '}}' || "{{city}}", '{{' + eventName + '}}', languages);
  replace(template, "{{city}}", '{{' + eventName + '}}', languages);
  replace(locations, "{{city}}", '{{' + eventName + '}}', languages);
  template = { ...template, ...metadata }

  
  const visibility = "private";
  const id = template.id

  if (!id) throw new Error("No id provided");

  const { latitude, longitude } = locations[0].coordinates;
  const geohash = geokit.hash({
    lat: latitude,
    lng: longitude,
  });

  template = {
    ...template,
    visibility,
    g: {
      geohash,
      geopoint: locations[0].coordinates,
    },
  };

  try {
    const db = firebase.firestore();

    await writeBatch({
      db,
      id,
      template,
      locations,
    });

    dispatch({
      type: SET_EVENT_ID,
      payload: id,
    });
    dispatch(
      setInfo({
        status: 200,
        info: "Success! Event Saved",
      })
    );

    // await dispatch(getTemplateLocations(id));
    await dispatch(getCustomEventLocations(id));
  } catch (e) {
    console.log(e);
    dispatch(
      setInfo({
        status: 500,
        info: "An error occured, event not saved",
      })
    );
  }
};

export const translatePlaceholders = (markerKey, key, placeholders, value) => async (dispatch) => {
  try {
    dispatch({ type: TRANSLATE_LOADING })

    const translated = await Promise.all(_.map(placeholders, (val, placeholderKey) => {
      return (axios.post('https://us-central1-seekcity.cloudfunctions.net/translate', {
        text: value,
        target_lang: val.lng.toUpperCase(),
        source_lang: key.split('_')[1].toUpperCase(),
        key: placeholderKey
      })
  )}))
  
  const v = translated.map(d => d.data).reduce((obj, item) => ({...obj, [item.key]: item.translated}) ,{});
  _.forEach(placeholders, (val, key) => {
    placeholders[key]['value'] = v[key]
  })

  dispatch({
    type: BULK_SET_PLACEHOLDER,
    payload: {
      markerKey,
      placeholders,
    }
  })
  } catch(e) {
    dispatch({
      type: TRANSLATE_FAIL,
    })    
  }
}

export const translate = (marker, source = 'question_en') => async (dispatch) => {
  try {
    dispatch({ type: TRANSLATE_LOADING })
    const texts = {
      ...placeholder_questions,
      ..._.pickBy(marker, (val, key) => key.includes('question')),
    };
    const markerKey = marker['key'];
    const source_lang = source.split('_')[1].toUpperCase()
  
    const translated = await Promise.all(_.map(texts, (val, key) => {
      let target_lang = key.split('_')[1].toUpperCase();
      if (target_lang === 'EN') target_lang = 'EN-US'
  
      return (
        axios.post('https://us-central1-seekcity.cloudfunctions.net/translate', {
          text: marker[source].replaceAll('{', '').replaceAll('}', ''),
          target_lang,
          source_lang,
          key
        })
    )})) 
    
    const value = translated.map(d => d.data).reduce((obj, item) => ({...obj, [item.key]: item.translated}) ,{});

    dispatch(bulkEditMarker({
      key: markerKey,
      value
    }))
  } catch (e) {
    dispatch({
      type: TRANSLATE_FAIL,
    })
  }
}

export const updateMarker = (key, lat, lng) => ({
  type: UPDATE_MARKER,
  payload: { key, lat, lng },
});

export const moveMarkers = (center) => ({
  type: MOVE_MARKERS,
  payload: center,
});

export const setCenter = (center) => ({
  type: SET_CENTER,
  payload: center,
});

export const toggleOverlay = (mode) => ({
  type: TOGGLE_OVERLAY,
  payload: mode,
});

export const setActiveMarker = (key) => (dispatch) => {
  return dispatch({
    type: SET_ACTIVE_MARKER,
    payload: key,
  });
};

export const editMarker = ({ prop, text, key }) => ({
  type: EDIT_MARKER,
  payload: { prop, text, key },
});

export const bulkEditMarker = ({ value, key }) => ({
  type: BULK_EDIT_MARKER,
  payload: { value, key },
});

export const omitQuestion = (key, keys) => ({
  type: OMIT_QUESTION,
  payload: { key, keys },
})

export const setInfo = ({ info, status }) => ({
  type: SET_INFO,
  payload: { info, status },
});

export const setStartTime = (value) => ({
  type: SET_START_DATE,
  payload: value,
});

export const setPlaceholder = (markerKey, placeholderKey, value) => ({
  type: SET_PLACEHOLDERS,
  payload: {
    markerKey,
    placeholderKey,
    value,
  },
});
